import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { createBreakpoints } from '@chakra-ui/theme-tools';
import type { FC } from 'react';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.scss';
import { CookieConsent } from './components/CookieConsent';
import GeneralLayout from './components/layout/GeneralLayout';
import ScrollToTop from './components/ScrollToTop';
import Ejendom from './pages/Ejendom';
import Ejendomme from './pages/Ejendomme';
import Home from './pages/Home';
import Kontakt from './pages/Kontakt';
import LejerInfo from './pages/LejerInfo';
import NoMatch from './pages/NoMatch';

const breakpoints = createBreakpoints({
  sm: '30em',
  md: '48em',
  lg: '62em',
  xl: '80em',
  '2xl': '96em',
});

const theme = extendTheme({
  breakpoints,
  styles: {
    global: () => ({
      body: {
        bg: 'var(--bg)',
        color: 'var(--fg)',
      },
      p: {
        color: 'inherit',
      },
    }),
  },
  fonts: {
    heading: 'Newsreader',
    body: 'Inter',
  },
});

const App: FC = () => {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <GeneralLayout>
          <ScrollToTop>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/ejendomme" component={Ejendomme} />
              <Route exact path="/ejendom/:property" component={Ejendom} />
              <Route exact path="/kontakt" component={Kontakt} />
              <Route exact path="/lejerinfo" component={LejerInfo} />
              <Route exact path="*" component={NoMatch} />
            </Switch>
          </ScrollToTop>
        </GeneralLayout>

        <CookieConsent />
      </Router>
    </ChakraProvider>
  );
};

export default App;
